<script>
import Repositories from '@/repositories';
const OrdersRepository = Repositories.get('orders');
const OrderItemsRepository = Repositories.get('orderitems');
const ReportsRepository = Repositories.get('reports');
const SuppliersRepository = Repositories.get('suppliers');
const ItemSuppliersRepository = Repositories.get('itemSuppliers');
const KeyGenRepository = Repositories.get('keygen');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
const SingleConfigRepository = Repositories.get('singleconfigs');
import { DEFAULT_EMAILS } from '@/mixins/defaultEmail.js';
import ChangeValueModal from '@/components/widgets/modals/input-value';

import OrderPdfClass from '@/utils/PDFsGenerators/OrderPDF.js';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/fr';

import dateMixin from '@/mixins/dateMixin';

export default {
  components: {
    DatePicker,
    Loading,
    ChangeValueModal,
  },
  mixins: [DEFAULT_EMAILS, dateMixin],
  props: {
    order: Object,
    orderItems: { type: Array, default: null },
    modalId: { type: String, default: 'to-order-modal' },
  },
  data() {
    return {
      isLoading: false,
      orgName: '',
      emailConfig: null,
      orderItemsList: [],
      currentlyClicked: [],
      isLoadingMailButton: false,
      currentTab: 1,
      modalInfo: { defaultValue: '', mode: 'none' },
      loadingIdPublic: null,
      formObject: {
        number: '',
        receptionDate: null,
      },
    };
  },
  methods: {
    modalHidden() {
      this.formObject.number = '';
      this.formObject.receptionDate = null;
      this.$emit('modal-closed');
    },
    async modalShown() {
      this.isLoadingMailButton = true;
      this.orderItemsList = [];

      try {
        this.isLoading = true;

        this.formObject.number = '';
        this.formObject.receptionDate = null;
        if (this.orderItems == null && this.order != null) {
          this.currentTab =
            this.order.supplierDefaultMethod.toUpperCase() == 'PHONE' ? 1 : 0;
          this.isLoading = true;
          let resp2 = await OrderItemsRepository.customREST.getByOrder(
            this.order.idPublic
          );

          this.orderItemsList = resp2.data;
        } else {
          this.orderItemsList = this.orderItems;
        }
      } catch (error) {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }

      let promise1 = KeyGenRepository.customREST
        .getOrganisation()
        .then(({ data }) => (this.orgName = data.name));

      let promise2 = SingleConfigRepository.get('EmailsConfig')
        .then(({ data }) => {
          this.emailConfig = data;
        })
        .catch((e) => {
          if (e.response.status == 404) {
            this.emailConfig = [];
          } else {
            throw e.response;
          }
        });

      Promise.all([promise1, promise2])
        .then(() => {
          this.isLoadingMailButton = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
    async generateMail() {
      this.isLoadingMailButton = true;
      if (this.order.supplierDefaultMethod.toUpperCase() == 'PDF') {
        try {
          let response = await ReportsRepository.customREST.getOrderPdf(
            this.order.idPublic
          );

          let orderPDF = new OrderPdfClass();
          orderPDF.generate(await this.formatPdfContent(response.data));
          orderPDF.save(response.data.orderNumber + '.pdf');
        } catch {
          this.$toast.errorToast(this.$t('errors.errorGeneratingPdf'));
        }
      }

      window.open(this.mailtoString, '_blank');

      this.isLoadingMailButton = false;
    },
    formatPdfContent(content) {
      content.headers = {
        purchaseOrder: this.$t('reports.orders.purchaseOrder'),
        orderDate: this.$t('reports.orders.orderDate'),
        supplier: this.$t('reports.orders.supplier'),
        requiredDate: this.$t('reports.orders.requiredDate'),
        client: this.$t('reports.orders.client'),
        supplierAddress: this.$t('reports.orders.supplierAddress'),
        deliveryAddress: this.$t('reports.orders.deliveryAddress'),
        table: [
          { key: 'code', title: this.$t('reports.orders.clientCode') },
          { key: 'quantity', title: this.$t('reports.orders.qty') },
          {
            key: 'supplierCode',
            title: this.$t('reports.orders.supplierCode'),
          },
          { key: 'name', title: this.$t('reports.orders.description') },
          {
            key: 'supplierPrice',
            title: this.$t('reports.orders.unitaryCost'),
          },
          { key: 'totalPrice', title: this.$t('reports.orders.totalCost') },
        ],
        attention: this.$t('reports.orders.attention'),
        order: this.$t('reports.orders.order'),
        representative: this.$t('reports.orders.representative'),
        payment: this.$t('reports.orders.payment'),
        condition: this.$t('reports.orders.condition'),
        total: this.$t('reports.orders.total'),
        doneBy: this.$t('reports.orders.doneBy'),
      };

      content.createdOn = this.formatDate(content.createdOn);

      if (this.formObject.number != null && this.formObject.number.length > 0) {
        content.orderNumber = this.formObject.receptionDate;
      }

      if (this.formObject.receptionDate != null) {
        content.deliveryDate = this.formatDate(this.formObject.receptionDate);
      } else {
        content.deliveryDate = this.formatDate(content.deliveryDate);
      }

      content.items.map((item) => {
        item.supplierPrice = this.currencyFormatter
          .format(item.supplierPrice)
          .replace(/\u202F/g, ' ');
        item.totalPrice = this.currencyFormatter
          .format(item.totalPrice)
          .replace(/\u202F/g, ' ');
      });

      content.totalPrice = this.currencyFormatter
        .format(content.totalPrice)
        .replace(/\u202F/g, ' ');

      return content;
    },
    openLink(link) {
      window.open(link, '_blank');
    },
    onSubmit(emailOnly) {
      let apiWrapper = {
        ...this.order,
        externalNumber: this.formObject.number,
        receptionDate: this.formObject.receptionDate,
      };

      if (emailOnly) {
        apiWrapper.supplierStatus = 'EMAIL_SENT';
      } else {
        apiWrapper.isOrdered = true;
      }

      OrdersRepository.update(apiWrapper, this.order.idPublic)
        .then(() => {
          this.$emit('order-updated', apiWrapper);
          this.$bvModal.hide(this.modalId);
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    editLinkItem(itemSupplierIdPublic, oldValue) {
      this.modalInfo = {
        defaultValue: oldValue,
        mode: 'itemSupplier',
        idPublic: itemSupplierIdPublic,
      };
      this.$bvModal.show('value-change-modal');
    },
    editLinkSupplier(supplierIdPublic, oldValue) {
      this.modalInfo = {
        defaultValue: oldValue,
        mode: 'supplier',
        idPublic: supplierIdPublic,
      };
      this.$bvModal.show('value-change-modal');
    },
    valueChangedModal(newValue) {
      this.loadingIdPublic = this.modalInfo.idPublic;
      if (this.modalInfo.mode == 'supplier') {
        SuppliersRepository.get(this.modalInfo.idPublic)
          .then(({ data }) => {
            let apiWrapper = { ...data, link: newValue };
            SuppliersRepository.update(apiWrapper, this.modalInfo.idPublic)
              .then(() => {
                this.$emit('order-updated', {
                  ...this.order,
                  supplierLink: newValue,
                });
                this.loadingIdPublic = null;
              })
              .catch(() => {
                this.$toast.errorToast(this.$t('errors.errorLoading'));
                this.loadingIdPublic = null;
              });
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.loadingIdPublic = null;
          });
      } else {
        ItemSuppliersRepository.get(this.modalInfo.idPublic)
          .then(({ data }) => {
            let apiWrapper = { ...data, link: newValue };
            ItemSuppliersRepository.update(apiWrapper, this.modalInfo.idPublic)
              .then(() => {
                let foundIndex = this.orderItemsList.findIndex(
                  (x) => x.itemSupplierIdPublic == this.modalInfo.idPublic
                );

                if (foundIndex >= 0) {
                  this.orderItemsList = [
                    ...this.orderItemsList.slice(0, foundIndex),
                    {
                      ...this.orderItemsList[foundIndex],
                      itemSupplierLink: newValue,
                    },
                    ...this.orderItemsList.slice(foundIndex + 1),
                  ];
                }
                this.loadingIdPublic = null;
              })
              .catch(() => {
                this.$toast.errorToast(this.$t('errors.errorLoading'));
                this.loadingIdPublic = null;
              });
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.loadingIdPublic = null;
          });
      }
    },
    clickedOrderItem(orderItemIdPublic) {
      if (!this.currentlyClicked.includes(orderItemIdPublic)) {
        this.currentlyClicked.push(orderItemIdPublic);
      }
    },
  },
  computed: {
    externalLink() {
      return (
        process.env.VUE_APP_REDIRECT_URL +
        'externals/' +
        this.order.supplierLanguage +
        '/orders/' +
        this.$store.state.user.config.organisationCode +
        '/' +
        this.order.idPublic
      );
    },
    mailtoString() {
      if (this.order != null && this.emailConfig != null) {
        let currentEmailConfig = null;
        let emailConfigIndex = this.emailConfig.findIndex(
          (x) => x.language == this.order.supplierLanguage
        );

        if (emailConfigIndex < 0) {
          let defaultConfigIndex = DEFAULT_EMAILS.findIndex(
            (x) => x.language == this.order.supplierLanguage
          );

          if (defaultConfigIndex >= 0) {
            currentEmailConfig = DEFAULT_EMAILS[defaultConfigIndex];
          }
        } else {
          currentEmailConfig = this.emailConfig[emailConfigIndex];
        }

        if (currentEmailConfig != null) {
          let title = currentEmailConfig.approveOrderTitle
            .replaceAll('[[COMPANY]]', this.orgName)
            .replaceAll('[[EXT_NUMBER]]', this.formObject.number)
            .replaceAll('[[SUPPLIER]]', this.order.supplierName)
            .replaceAll('[[PO_NUMBER]]', this.order.number)
            .replaceAll('[[NUMBER_OF_ITEMS]]', this.order.totalItemsQuantity)
            .replaceAll('[[ETA_DATE]]', this.formObject.receptionDate)
            .replaceAll('[[LINK]]', this.externalLink);

          let message = currentEmailConfig.approveOrderText
            .replaceAll('[[COMPANY]]', this.orgName)
            .replaceAll('[[EXT_NUMBER]]', this.formObject.number)
            .replaceAll('[[SUPPLIER]]', this.order.supplierName)
            .replaceAll('[[PO_NUMBER]]', this.order.number)
            .replaceAll('[[NUMBER_OF_ITEMS]]', this.order.totalItemsQuantity)
            .replaceAll('[[ETA_DATE]]', this.formObject.receptionDate)
            .replaceAll('[[LINK]]', this.externalLink);

          return `mailto:${this.order.supplierEmail}?subject=${title}&body=${message}`;
        }
      }

      return '';
    },
    currencyFormatter() {
      return this.$store.state.cache.currencyFormatter;
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      :id="modalId"
      scrollable
      size="xl"
      :title="$t('orders.orderr')"
      @shown="modalShown()"
      @hide="modalHidden()"
      ok-variant="danger"
    >
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#f1b44c"
        :width="70"
        :height="70"
        loader="dots"
        :is-full-page="false"
      >
      </loading>

      <b-container v-if="order != null" fluid>
        <b-row>
          <b-col>
            <b-form-group
              id="input-group-number"
              :label="$t('orders.externalNumber')"
              label-for="input-number"
            >
              <b-form-input
                id="input-number"
                v-model="formObject.number"
                type="text"
                :placeholder="$t('general.number')"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-rows"
              :label="$t('orders.receptionDate')"
              label-for="input-rows"
            >
              <date-picker
                v-model="formObject.receptionDate"
                :first-day-of-week="1"
                format="YYYY-MM-DD"
                value-type="format"
                :lang="$i18n.locale"
              >
              </date-picker>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-tabs
              content-class="mt-3"
              v-model="currentTab"
              fill
              active-nav-item-class="font-weight-bold text-primary"
            >
              <b-tab :title="$t('suppliers.email')" class="pt-4">
                <b-row>
                  <b-col cols="12" class="text-center">
                    <div v-if="order.supplierEmail != null">
                      <h2
                        v-for="(email, index) in order.supplierEmail.split(';')"
                        :key="index"
                      >
                        {{ email }}
                      </h2>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="pt-2">
                  <b-col>
                    <b-button
                      block
                      variant="primary"
                      :disabled="isLoadingMailButton"
                      @click="generateMail"
                      style="height: 40px"
                    >
                      <i
                        v-if="isLoadingMailButton"
                        class="bx bx-loader-alt bx-spin"
                        style="
                          font-size: 1.5em;
                          color: white;
                          vertical-align: middle;
                        "
                      >
                      </i>
                      <span v-else>
                        {{ $t('orders.generateEmail') }}
                      </span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab :title="$t('suppliers.phoneLink')" class="pt-4">
                <b-row>
                  <b-col cols="12" class="text-center">
                    <h2
                      >{{ order.supplierName }}
                      <i
                        v-if="order.supplierIdPublic == loadingIdPublic"
                        class="bx bx-loader-alt bx-spin text-warning"
                        style="font-size: 0.8em; vertical-align: middle"
                      >
                      </i>
                      <a
                        v-else-if="
                          order.supplierLink != null &&
                            order.supplierLink.length > 0
                        "
                        @click.right.prevent="
                          editLinkSupplier(
                            order.supplierIdPublic,
                            order.supplierLink
                          )
                        "
                        :href="addHttps(order.supplierLink)"
                        target="_blank"
                        style="font-size: 0.8em"
                      >
                        <i class="fas fa-link"></i>
                      </a>
                      <i
                        v-else
                        class="fas fa-link text-secondary"
                        style="cursor: pointer; font-size: 0.8em"
                        @click="editLinkSupplier(order.supplierIdPublic)"
                        @click.right.prevent="
                          editLinkSupplier(order.supplierIdPublic)
                        "
                      ></i>
                    </h2>
                  </b-col>
                  <b-col cols="12" class="text-center">
                    <h2>{{ order.supplierPhone }}</h2>
                    <h5>{{ order.supplierContact }}</h5>
                  </b-col>
                </b-row>
                <b-row class="custom-grid-header">
                  <b-col cols="4" class="custom-grid-header-column">{{
                    $t('general.code')
                  }}</b-col>
                  <b-col cols="5" class="custom-grid-header-column">{{
                    $t('items.item')
                  }}</b-col>
                  <b-col cols="2" class="custom-grid-header-column text-center">
                    {{ $t('items.total') }}
                  </b-col>
                  <b-col
                    cols="1"
                    class="custom-grid-header-column text-center"
                    >{{ $t('general.link') }}</b-col
                  >
                </b-row>

                <b-row
                  v-for="orderItem in orderItemsList"
                  :key="orderItem.idPublic"
                  :orderItem="orderItem"
                  class="custom-grid-row"
                >
                  <b-col cols="4" class="custom-grid-row-column">
                    {{ orderItem.itemCode }}
                  </b-col>
                  <b-col cols="5" class="custom-grid-row-column">
                    {{ orderItem.itemName }}
                  </b-col>
                  <b-col cols="2" class="custom-grid-row-column text-center">
                    {{ orderItem.totalUnits }}
                  </b-col>
                  <b-col cols="1" class="custom-grid-row-column text-center">
                    <i
                      v-if="orderItem.itemSupplierIdPublic == loadingIdPublic"
                      class="bx bx-loader-alt bx-spin text-warning"
                      style="font-size: 1.2em; vertical-align: middle"
                    >
                    </i>
                    <a
                      v-else-if="
                        orderItem.itemSupplierLink != null &&
                          orderItem.itemSupplierLink.length > 0
                      "
                      :href="addHttps(orderItem.itemSupplierLink)"
                      @click.left="clickedOrderItem(orderItem.idPublic)"
                      @click.right.prevent="
                        editLinkItem(
                          orderItem.itemSupplierIdPublic,
                          orderItem.itemSupplierLink
                        )
                      "
                      target="_blank"
                      style="font-size: 1.2em"
                    >
                      <i
                        v-if="currentlyClicked.includes(orderItem.idPublic)"
                        class="fas fa-check text-success"
                      ></i>
                      <i v-else class="fas fa-link"></i>
                    </a>

                    <i
                      v-else
                      class="fas fa-link text-secondary"
                      style="cursor: pointer; font-size: 1.2em"
                      @click="editLinkItem(orderItem.itemSupplierIdPublic)"
                      @click.right.prevent="
                        editLinkItem(orderItem.itemSupplierIdPublic)
                      "
                    ></i>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-container>

      <ChangeValueModal
        @save="valueChangedModal"
        :defaultValue="modalInfo.defaultValue"
        :title="$t('general.link')"
      />
      <template #modal-footer>
        <b-button @click="$bvModal.hide(modalId)" size="sm" variant="danger">
          {{ $t('general.cancel') }}
        </b-button>
        <b-button
          v-if="currentTab == 0"
          @click="onSubmit(true)"
          size="sm"
          variant="primary"
        >
          {{ $t('orders.markEmailSent') }}
        </b-button>
        <b-button @click="onSubmit(false)" size="sm" variant="primary">
          {{ $t('orders.markOrdered') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
